module.exports = __webpack_public_path__ + "img/pro3.29471edc.png";